module.exports = __webpack_public_path__ + "static/media/WebRTC_signalling.04b3f57d.png";